import MutateApiHookType from '@trinsly/common/src/types/mutate-api-hook-type'
import { useMutation } from 'react-query'
import createOrganizationMemberInviteService from 'services/settings/create-organization-member-invite'
import useGetUserSettings from './use-get-user-settings'

export type UseUpdateOrganizationMemberInviteProps =
  {} & MutateApiHookType<Invite>

function useCreateOrganizationMemberInvite({
  onSuccess,
  onError,
}: UseUpdateOrganizationMemberInviteProps) {
  const { refetch } = useGetUserSettings()

  const { mutate: fetch, isLoading: pending } = useMutation(
    createOrganizationMemberInviteService,
    {
      onSuccess: async (data) => {
        await refetch()
        onSuccess?.(data)
      },
      onError,
    }
  )

  return {
    fetch,
    pending,
  }
}

export default useCreateOrganizationMemberInvite
